<template lang="pug">
.v-field-check-list.field-check-list(v-if="field")
	label.field-check-list__label.field-label(v-if="field.label" :for="uniqueId") {{field.label}}
	.field-check-list__items(v-if="field.options")
		v-field-checkbox.field-check-list__item(v-if="field.selectAll" :field="{value: selectAllValue, text: field.selectAll.text}" :model-value="selectAllValue" @update:model-value="handlerSelectAll")
		v-field-checkbox.field-check-list__item(v-for="option in field.options" :field="{...option, parent: field}" :model-value="option.value" @update:model-value="handlerInput")
</template>

<script>
import uniqueId from '../scripts/helpers/uniqueId.js';

export default {

	props: {
		field: {
			type: Object,
			default: null,
			required: true
		},

		modelValue: {
			type: [Object, String, Number, Boolean, Symbol, Date],
			default: null
		}
	},

	emits: [
		'update:model-value'
	],
	
	data() {
		return {
			localValue: null,
			uniqueId: uniqueId('field-select_'),
			selectAllValue: false
		};
	},

	watch: {
		modelValue() {
			this.updateLocalValue();
		},

		field(state) {
			if (state?.options[0]) {
				this.checkAllOptions(state.options[0]?.value, state?.options[0]);
			}
		}
	},

	created() {
		this.updateLocalValue();
		if (this.field?.options[0]) {
			this.checkAllOptions(this.field.options[0]?.value, this.field?.options[0]);
		}
	},

	methods: {
		updateLocalValue() {
			this.localValue = this.modelValue;
		},

		handlerInput(value, field) {
			this.$emit('update:model-value', this.localValue, this.field);
			this.checkAllOptions(value, field);
		},

		handlerSelectAll(val) {
			this.selectAllValue = val;
			this.field.options.forEach((option, i) => {
				option.value = val;
			})
			this.$emit('update:model-value', this.localValue, this.field);
		},

		checkAllOptions(value, field) {
			let self = this.field.options.find(option => option.id === field.id);
			self.value = value;
			let alt = this.field.options.find((option, i) => option.value !== value);
			this.selectAllValue = value && !alt;
		}
	}
}
</script>
